import ajax from '../api';

export default class Condition {

  constructor (selectorId, conditionName) {
    this.selectorId = selectorId;
    this.conditionName = conditionName;
  }

  setValue (value) {
    return ajax(this.path, {
      type: 'POST',
      data: JSON.stringify(value),
      contentType: 'application/json'
    });
  }

  getValue () {
    return ajax(this.path, {dataType: 'json'});
  }

  get path () {
    // encode twice to bypass Spring's UrlPathHelper
    const encodedConditionName = encodeURIComponent(encodeURIComponent(this.conditionName));
    return `/selectors/${this.selectorId}/conditions/${encodedConditionName}`;
  }

}
